(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blank-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('section-wrapper')) {
    customElements.define('section-wrapper', class extends HTMLElement{});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spaces-content-cards')) {
  customElements.define('spaces-content-cards', class extends HTMLElement {});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-rsvp"] && !Shopify.designMode) return;
  try {
    
  const RSVP_FIELD_NAMES = {
    firstName: 'first_name',
    lastName: 'last_name',
    email: 'email',
  };

  if (!customElements.get('spaces-rsvp-form')) {
    customElements.define(
      'spaces-rsvp-form',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.message = this.querySelector('[data-message]');
          this.confirmation = this.querySelector('[data-confirmation]');
          this.captchaToken = null;
          this.captchaWidgetId = null;

          this.form.addEventListener('submit', (event) => this.#submit(event));
          this.form.addEventListener('input', () => this.#updateVisibility());
          this.form.addEventListener('change', () => this.#updateVisibility());

          this.#updateVisibility();
          this.#setupCaptcha();
          this.#loadStatus();
        }

        get apiEndpoint() {
          return (this.getAttribute('api-endpoint') || '').replace(/\/$/, '');
        }

        get eventHandle() {
          return this.getAttribute('event-handle');
        }

        #template(name) {
          return this.querySelector(`template[data-template="${name}"]`);
        }

        #message(text) {
          this.message.textContent = text;
          this.message.hidden = false;
        }

        #clearMessage() {
          this.message.textContent = '';
          this.message.hidden = true;
        }

        async #loadStatus() {
          try {
            const response = await fetch(
              `${this.apiEndpoint}/rsvp/${this.eventHandle}`,
              {headers: {Accept: 'application/json'}},
            );
            if (!response.ok) return;
            const {status} = await response.json();

            if (status === 'not_available') {
              this.hidden = true;
              return;
            }
            if (status === 'closed' || status === 'full') {
              const template = this.#template(status);
              this.form.replaceWith(
                Object.assign(document.createElement('p'), {
                  className: 'event-rsvp-notice',
                  textContent: template ? template.innerHTML.trim() : '',
                }),
              );
              return;
            }
            if (status === 'waitlist') {
              const banner = this.#template('waitlist-banner');
              if (banner) {
                this.form.prepend(
                  Object.assign(document.createElement('p'), {
                    className: 'event-rsvp-banner',
                    textContent: banner.innerHTML.trim(),
                  }),
                );
              }
              const label = this.getAttribute('data-waitlist-label');
              const button = this.querySelector('.event-rsvp-submit');
              if (label && button) button.textContent = label;
            }
          } catch (error) {
            // Leave the form usable; the POST reports real failures.
          }
        }

        #updateVisibility() {
          this.querySelectorAll('[data-show-if-name]').forEach((wrapper) => {
            const target = wrapper.getAttribute('data-show-if-name');
            const expected = wrapper.getAttribute('data-show-if-value');
            const inputs = wrapper.querySelectorAll('input, select, textarea');

            let visible = false;
            this.querySelectorAll(`[name="answer:${target}"]`).forEach((el) => {
              if (el.type === 'checkbox' || el.type === 'radio') {
                if (el.checked && el.value === expected) visible = true;
              } else if (el.value === expected) {
                visible = true;
              }
            });

            wrapper.hidden = !visible;
            inputs.forEach((el) => {
              el.disabled = !visible;
            });
          });
        }

        #validateRequiredGroups() {
          this.querySelectorAll('[data-required-group]').forEach((wrapper) => {
            const boxes = wrapper.querySelectorAll('input[type="checkbox"]');
            if (!boxes.length) return;
            const anyChecked = Array.from(boxes).some((box) => box.checked);
            boxes[0].setCustomValidity(
              anyChecked ? '' : 'Choose at least one option',
            );
          });
        }

        #buildAnswers() {
          const byName = new Map();
          this.querySelectorAll(
            'input[name^="answer:"], select[name^="answer:"], textarea[name^="answer:"]',
          ).forEach((el) => {
            if (el.disabled) return;
            if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) {
              return;
            }

            const name = el.getAttribute('name');
            let value = el.value;
            if (value === '__other__') {
              const other = this.querySelector(`[data-other-for="${name}"]`);
              value = other && other.value.trim() ? other.value.trim() : 'Other';
            }
            if (!value) return;

            const label = el.getAttribute('data-label') || name.slice(7);
            const entry = byName.get(name);
            if (entry) entry.values.push(value);
            else byName.set(name, {label, values: [value]});
          });

          return Array.from(byName.values()).map(({label, values}) => ({
            label,
            value: values.join(', '),
          }));
        }

        #utm() {
          const params = new URLSearchParams(window.location.search);
          const utm = {};
          for (const key of [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_term',
            'utm_content',
          ]) {
            const value = params.get(key);
            if (value) utm[key] = value;
          }
          return utm;
        }

        #resetCaptcha() {
          if (this.captchaToken && window.hcaptcha) {
            window.hcaptcha.reset(this.captchaWidgetId);
            this.captchaToken = null;
          }
        }

        #showConfirmation(payload) {
          this.form.hidden = true;
          this.confirmation.hidden = false;

          const attending = payload.status === 'attending';
          const headingName = attending ? 'success-heading' : 'waitlist-heading';
          const heading = this.#template(headingName);
          const headingEl = this.querySelector('[data-confirmation-heading]');
          if (heading && headingEl) headingEl.textContent = heading.innerHTML.trim();

          if (attending) {
            const messageTemplate = this.#template('success-message');
            const messageEl = this.querySelector('[data-confirmation-message]');
            if (messageTemplate && messageEl) {
              messageEl.innerHTML = messageTemplate.innerHTML;
            }

            const code = this.querySelector('[data-code]');
            if (code && payload.orderName) {
              code.textContent = `Check-in code: ${payload.orderName.replace('#', '')}`;
              code.hidden = false;
            }

            const calendar = this.querySelector('[data-calendar]');
            if (calendar && payload.googleCalendarUrl) {
              calendar.href = payload.googleCalendarUrl;
              calendar.hidden = false;
            }

            const ics = this.querySelector('[data-ics]');
            if (ics && payload.icsUrl) {
              ics.href = payload.icsUrl;
              ics.hidden = false;
            }
          }

          const ticket = this.querySelector('[data-ticket]');
          if (ticket && payload.ticketUrl) {
            ticket.href = payload.ticketUrl;
            ticket.hidden = false;
          }
        }

        async #submit(event) {
          event.preventDefault();
          this.#clearMessage();
          this.#validateRequiredGroups();
          if (!this.form.reportValidity()) return;

          const button = this.querySelector('.event-rsvp-submit');
          if (button) button.disabled = true;

          const payload = {
            firstName: this.form.elements.first_name.value.trim(),
            lastName: this.form.elements.last_name.value.trim(),
            email: this.form.elements.email.value.trim(),
            consent: this.form.elements.consent.checked,
            answers: this.#buildAnswers(),
            utm: this.#utm(),
            captchaToken: this.captchaToken,
            company_website: this.form.elements.company_website.value,
          };

          try {
            const response = await fetch(
              `${this.apiEndpoint}/rsvp/${this.eventHandle}`,
              {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload),
              },
            );
            const body = await response.json().catch(() => ({}));

            if (response.status === 201) {
              this.#showConfirmation(body);
            } else if (response.status === 200) {
              this.#message(
                "You're already on the list — check your inbox for your confirmation.",
              );
            } else if (response.status === 400 && body.fieldErrors) {
              Object.entries(body.fieldErrors).forEach(([field, text]) => {
                const name = RSVP_FIELD_NAMES[field];
                const input = name && this.form.elements[name];
                if (input) {
                  input.setCustomValidity(text);
                  input.addEventListener(
                    'input',
                    () => input.setCustomValidity(''),
                    {once: true},
                  );
                }
              });
              this.form.reportValidity();
              this.#resetCaptcha();
            } else if (response.status === 409) {
              this.#message(body.error || 'This event is at capacity.');
              this.#resetCaptcha();
            } else {
              this.#message(body.error || "We couldn't save your RSVP. Please try again.");
              this.#resetCaptcha();
            }
          } catch (error) {
            this.#message("We couldn't save your RSVP. Please try again.");
          } finally {
            if (button) button.disabled = false;
          }
        }

        async #setupCaptcha() {
          const siteKey = this.getAttribute('hcaptcha-site-key');
          if (!siteKey) return;

          const container = this.querySelector('.rsvp-captcha');
          if (!container) return;

          if (!window.hcaptcha) {
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = 'https://js.hcaptcha.com/1/api.js?render=explicit';
              script.async = true;
              script.onload = resolve;
              script.onerror = reject;
              document.head.appendChild(script);
            }).catch(() => {});
          }

          if (!window.hcaptcha) return;
          this.captchaWidgetId = window.hcaptcha.render(container, {
            sitekey: siteKey,
            callback: (token) => {
              this.captchaToken = token;
            },
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spaces-faqs')) {
  customElements.define('spaces-faqs', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
      
      // Add click listener to toggle nav
      const navHeader = this.shadowRoot.querySelector('.nav-header');
      if (navHeader) {
        navHeader.addEventListener('click', (e) => {
          const section = e.target.closest('section');
          if (section) {
            section.toggleAttribute('open');
          }
        });
      }
      
      // Handle anchor link clicks inside shadow DOM
      const links = this.shadowRoot.querySelectorAll('a[href^="#"]');
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.getAttribute('href').substring(1);
          const targetElement = this.shadowRoot.getElementById(targetId);
          
          if (targetElement) {
            targetElement.scrollIntoView({ 
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spaces-footer')) {
    customElements.define(
      'spaces-footer',
      class extends HTMLElement {
        constructor() {
          super();

          // The shadow root is already attached declaratively
          const shadow = this.shadowRoot;

          if (shadow) {
            const backToTop = shadow.querySelector('.back-to-top');
            if (backToTop) {
              backToTop.addEventListener('click', () => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              });
            }
          }
        }
        connectedCallback() {
          if (!this.shadowRoot) {
            loadTemplateToShadowRoot(this);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spaces-marquee')) {
  customElements.define('spaces-marquee', class extends HTMLElement {
    constructor() {
      super();
      this.wrapper = null;
      this.content = null;
      this.resizeObserver = null;
      this.intersectionObserver = null;
      this.resizeTimeout = null;
      this.movementMode = 'automatic';
      this.contentWidth = 0;
      this.isVisible = false;
      this.scrollStartY = 0;
      this.scrollOffsetBase = 0;
      
      // Manual mode state
      this.manualState = {
        isDragging: false,
        startX: 0,
        startOffset: 0,
        currentOffset: 0,
        pointerId: null,
        velocity: 0,
        lastX: 0,
        lastTime: 0,
        momentumRAF: null,
        lastMomentumTime: 0
      };
    }

    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
      this.wrapper = this.shadowRoot.querySelector('[data-ref="wrapper"]');
      this.content = this.shadowRoot.querySelector('[data-ref="content"]');
      
      if (!this.wrapper || !this.content) {
        console.warn('SpacesMarquee: Missing required wrapper or content elements');
        return;
      }
  
      const items = this.content.querySelector('.items');
      if (!items || items.children.length === 0) {
        console.warn('SpacesMarquee: Missing required items');
        return;
      }
  
      this.movementMode = this.getAttribute('movement-mode') || 'automatic';
      this.movementDirection = this.getAttribute('movement-direction') || 'normal';
      this.init();
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      } else {
        // Clean up fallback window resize listener if ResizeObserver wasn't available
        window.removeEventListener('resize', this.handleResize);
      }
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
      window.removeEventListener('scroll', this.handleScroll);
      if (this.manualState.momentumRAF) {
        cancelAnimationFrame(this.manualState.momentumRAF);
        this.manualState.momentumRAF = null;
      }
      this.removeManualListeners();
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }
  
    init() {
      // Both modes use the same setup: content width calculation and duplication
      this.calculateContentWidth();
      this.duplicateContent();
      
      if (this.movementMode === 'manual') {
        this.setupManualMode();
      } else {
        this.setupAutomaticMode();
      }

      this.setupResize();
    }
  
    calculateContentWidth() {
      const gap = parseFloat(getComputedStyle(this.content).getPropertyValue('gap')) || 24;
      this.contentWidth = this.content.offsetWidth + gap;
      this.style.setProperty('--marquee-content-width', `${this.contentWidth}px`);
    }
  
    duplicateContent() {
      // Remove existing clones
      const existingClones = this.wrapper.querySelectorAll('[data-cloned="true"]');
        existingClones.forEach(clone => clone.remove());
      
      // Calculate how many clones we need to fill the viewport
      const numberOfClonesNeeded = Math.ceil(this.offsetWidth / this.content.offsetWidth) + 1;
      
      for (let i = 0; i < numberOfClonesNeeded; i++) {
        const clone = this.content.cloneNode(true);
        clone.setAttribute('data-cloned', 'true');
        this.wrapper.appendChild(clone);

        // Clone shadow DOM for any shopify blocks
        const originalItems = this.content.querySelectorAll('.shopify-block');
        const cloneItems = clone.querySelectorAll('.shopify-block');
        for (const [index, item] of originalItems.entries()) {
          const originalMarqueeItem = item.children[0];
          const cloneMarqueeItem = cloneItems[index].children[0];
          if (originalMarqueeItem && cloneMarqueeItem && originalMarqueeItem.shadowRoot) {
            cloneMarqueeItem.attachShadow({ mode: 'open' });
            cloneMarqueeItem.shadowRoot.innerHTML = originalMarqueeItem.shadowRoot.innerHTML;
          }
        }
      }
    }
  
    setupAutomaticMode() {
      this.removeAttribute('data-disabled');
      this.removeManualListeners();
      this.teardownScrollSync();
      this.wrapper.style.transform = '';
      this.calculateSpeed();
    }
  
    calculateSpeed() {
      const speedSetting = parseFloat(this.getAttribute('speed-factor')) || 5;
      // Map speed setting (1-10) to pixels per second (20-200)
      // Lower setting = slower movement = fewer pixels per second
      const pixelsPerSecond = 20 * speedSetting;
      // Calculate duration in seconds for one full content width
      const duration = Math.max(this.contentWidth / pixelsPerSecond, 1);
      this.style.setProperty('--marquee-speed', `${duration}s`);
    }
    
    setupManualMode() {
      this.setAttribute('data-disabled', 'true');
      this.manualState.currentOffset = 0;
      this.wrapper.style.transform = 'translateX(0)';
      this.addManualListeners();
      this.setupScrollSync();
    }
    
    addManualListeners() {
      this.removeManualListeners();
      this.wrapper.addEventListener('pointerdown', this.handlePointerDown);
      this.wrapper.addEventListener('pointermove', this.handlePointerMove);
      this.wrapper.addEventListener('pointerup', this.handlePointerUp);
      this.wrapper.addEventListener('pointerleave', this.handlePointerUp);
      this.wrapper.addEventListener('pointercancel', this.handlePointerUp);
    }
    
    removeManualListeners() {
      if (!this.wrapper) return;
      this.wrapper.removeEventListener('pointerdown', this.handlePointerDown);
      this.wrapper.removeEventListener('pointermove', this.handlePointerMove);
      this.wrapper.removeEventListener('pointerup', this.handlePointerUp);
      this.wrapper.removeEventListener('pointerleave', this.handlePointerUp);
      this.wrapper.removeEventListener('pointercancel', this.handlePointerUp);
      this.wrapper.classList.remove('is-dragging');
    }
  
    setupResize() {
      // Use ResizeObserver for better performance and element-specific resize detection
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.handleResize();
        });
        this.resizeObserver.observe(this);
      } else {
        // Fallback to window resize event for older browsers
        window.addEventListener('resize', this.handleResize);
      }
    }

    handleResize = () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.calculateContentWidth();
        this.duplicateContent();
        if (this.movementMode === 'manual') {
          this.normalizeManualOffset();
        } else {
          this.calculateSpeed();
        }
      }, 250);
    }

    normalizeManualOffset() {
      // Keep current position within one content cycle
      if (this.contentWidth > 0) {
        this.manualState.currentOffset = ((this.manualState.currentOffset % this.contentWidth) + this.contentWidth) % this.contentWidth;
        if (this.manualState.currentOffset > 0) {
          this.manualState.currentOffset -= this.contentWidth;
        }
        this.applyManualOffset(false);
      }
    }

    applyManualOffset(animate = true) {
      if (!this.wrapper) return;
      
      // Normalize offset to create infinite loop
      // When offset goes past -contentWidth, loop back to 0
      // When offset goes past 0, loop back to -contentWidth
      let normalizedOffset = this.manualState.currentOffset;
      
      if (normalizedOffset <= -this.contentWidth) {
        normalizedOffset = normalizedOffset % this.contentWidth;
        this.manualState.currentOffset = normalizedOffset;
      } else if (normalizedOffset > 0) {
        normalizedOffset = -this.contentWidth + (normalizedOffset % this.contentWidth);
        this.manualState.currentOffset = normalizedOffset;
      }
      
      // Use class toggle instead of inline styles for better performance
      if (animate) {
        this.wrapper.classList.remove('no-transition');
      } else {
        this.wrapper.classList.add('no-transition');
      }
      
      this.wrapper.style.transform = `translateX(${normalizedOffset}px)`;
    }

    handlePointerDown = (event) => {
      event.preventDefault();
      
      // Cancel any ongoing momentum
      if (this.manualState.momentumRAF) {
        cancelAnimationFrame(this.manualState.momentumRAF);
        this.manualState.momentumRAF = null;
      }
      
      this.manualState.isDragging = true;
      this.manualState.pointerId = event.pointerId;
      this.manualState.startX = event.clientX;
      this.manualState.startOffset = this.manualState.currentOffset;
      this.manualState.lastX = event.clientX;
      this.manualState.lastTime = Date.now();
      this.manualState.velocity = 0;
      this.wrapper.classList.add('is-dragging');
      this.wrapper.setPointerCapture(event.pointerId);
    }

    handlePointerMove = (event) => {
      if (!this.manualState.isDragging || event.pointerId !== this.manualState.pointerId) {
        return;
      }
      event.preventDefault();
      
      const currentTime = Date.now();
      const currentX = event.clientX;
      const timeDelta = currentTime - this.manualState.lastTime;
      
      // Calculate velocity (pixels per millisecond)
      if (timeDelta > 0) {
        const distance = currentX - this.manualState.lastX;
        const newVelocity = distance / timeDelta;
        // Use simple assignment for the first calculation, then EMA for smoothing
        this.manualState.velocity = this.manualState.velocity === 0
          ? newVelocity
          : this.manualState.velocity * 0.8 + newVelocity * 0.2;
      }
      
      this.manualState.lastX = currentX;
      this.manualState.lastTime = currentTime;
      
      const delta = event.clientX - this.manualState.startX;
      this.manualState.currentOffset = this.manualState.startOffset + delta;
      this.applyManualOffset(false);
    }

    handlePointerUp = (event) => {
      if (!this.manualState.isDragging || event.pointerId !== this.manualState.pointerId) {
        return;
      }

      this.manualState.isDragging = false;
      this.manualState.pointerId = null;
      this.wrapper.classList.remove('is-dragging');
      
      // Apply momentum if velocity is significant
      const velocityThreshold = 0.1; // pixels per millisecond
      if (Math.abs(this.manualState.velocity) > velocityThreshold) {
        this.startMomentum();
      } else {
        this.applyManualOffset(true);
      }
      
      if (this.wrapper.hasPointerCapture(event.pointerId)) {
        this.wrapper.releasePointerCapture(event.pointerId);
      }
    }

    startMomentum() {
      const friction = 0.95; // Decay factor per frame
      const minVelocity = 0.05; // Stop when velocity is very small
      this.manualState.lastMomentumTime = 0;
      
      const animate = (currentTime) => {
        if (!this.manualState.lastMomentumTime) {
          this.manualState.lastMomentumTime = currentTime;
        }
        
        const deltaTime = currentTime - this.manualState.lastMomentumTime;
        this.manualState.lastMomentumTime = currentTime;
        
        // Apply velocity to offset using actual time delta
        this.manualState.currentOffset += this.manualState.velocity * deltaTime;
        this.applyManualOffset(false);
        
        // Apply friction
        this.manualState.velocity *= friction;
        
        // Continue animation if velocity is still significant and not dragging
        if (Math.abs(this.manualState.velocity) > minVelocity && !this.manualState.isDragging) {
          this.manualState.momentumRAF = requestAnimationFrame(animate);
        } else {
          this.manualState.momentumRAF = null;
          this.manualState.velocity = 0;
          this.manualState.lastMomentumTime = 0;
          // Update scroll base for scroll-sync after momentum stops
          this.scrollOffsetBase = this.manualState.currentOffset;
          this.scrollStartY = window.scrollY;
        }
      };
      
      this.manualState.momentumRAF = requestAnimationFrame(animate);
    }

    setupScrollSync() {
      // Setup intersection observer to track visibility
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible && !this.manualState.isDragging) {
              // Reset scroll sync base when becoming visible
              this.scrollStartY = window.scrollY;
              this.scrollOffsetBase = this.manualState.currentOffset;
            }
          });
        }, {
          threshold: 0,
          rootMargin: '0px'
        });
        this.intersectionObserver.observe(this);
      }

      // Setup scroll listener
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    teardownScrollSync() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      window.removeEventListener('scroll', this.handleScroll);
      this.isVisible = false;
    }

    handleScroll = () => {
      // Only apply scroll sync when visible and not dragging
      if (!this.isVisible || this.manualState.isDragging) {
        return;
      }

      // If momentum is running, cancel it and update scroll base to current position
      // This prevents jumping when scrolling starts during momentum
      if (this.manualState.momentumRAF) {
        cancelAnimationFrame(this.manualState.momentumRAF);
        this.manualState.momentumRAF = null;
        this.manualState.velocity = 0;
        this.manualState.lastMomentumTime = 0;
        // Update scroll base to current position so scroll sync continues smoothly
        this.scrollOffsetBase = this.manualState.currentOffset;
        this.scrollStartY = window.scrollY;
      }

      const scrollDelta = window.scrollY - this.scrollStartY;
      // Get speed factor and apply it to scroll delta
      // Speed factor affects how quickly horizontal translation happens when scrolling vertically
      const speedFactor = parseFloat(this.getAttribute('speed-factor')) || 5;
      // Map speed setting (1-10) to scroll multiplier (0.2-2.0)
      // Lower setting = slower movement = less horizontal translation per vertical scroll
      const scrollMultiplier = speedFactor / 5;
      // Respect movement direction: 'normal' moves left (negative), 'reverse' moves right (positive)
      const directionMultiplier = this.movementDirection === 'reverse' ? 1 : -1;
      this.manualState.currentOffset = this.scrollOffsetBase + (scrollDelta * scrollMultiplier * directionMultiplier);
      this.applyManualOffset(false);
    }
  });
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spaces-navigation')) {
    class SpacesNavigation extends HTMLElement {
      connectedCallback() {
        if (!this.shadowRoot) return;

        const toggle = this.shadowRoot.querySelector('.mobile-toggle');
        const menu = this.shadowRoot.querySelector('.menu');

        if (toggle && menu) {
          toggle.addEventListener('click', () => {
            menu.classList.toggle('mobile-open');
          });
        }
      }
    }
    customElements.define('spaces-navigation', SpacesNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spaces-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spaces-details')) {
  customElements.define('spaces-details', class extends HTMLElement {
    connectedCallback() {
      // Sync open state to child title components (for Safari/Firefox compatibility)
      this.shadowRoot?.querySelectorAll('details').forEach(details => {
        const title = details.querySelector('spaces-details-title');
        if (!title) return;
        
        // Set initial state
        if (details.open) title.setAttribute('open', '');
        
        // Listen for toggle events
        details.addEventListener('toggle', () => {
          if (details.open) {
            title.setAttribute('open', '');
          } else {
            title.removeAttribute('open');
          }
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
